import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
  width: auto;
  height: auto;
  min-width: 263px;
  padding: 1rem;
  
  gap: 0.625rem;
  display: flex;
  flex-direction: column;
  
  border-radius: 1rem;
  background-color: #F8F8F9;

  @media (max-width: 768px) {
    background-color: transparent;
  } 
`;

export const PricipalFilters = styled.div`
  gap: 1rem;
  display: flex;
  margin-bottom: 0.5rem;
  flex-direction: column;
`;

export const OtherFilters = styled.div`
  gap: 1rem;
  display: flex;
  flex-direction: column;

  >div{
    width: auto !important;

    >div{
      width: auto;
      min-width: auto;

      justify-content: space-between;

      @media (max-width: 756px) {
         max-width: none;
      }
    }
  }

  >div>div:nth-of-type(2){
    min-height: 2rem;
    height: auto;
    max-height: 20rem;
    overflow-y: auto;
    align-items: flex-start;
    text-align: justify;

    @media (max-width: 756px) {
      max-height: 10rem;
    }

    &::-webkit-scrollbar {
    width: 4px; 
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 16px;
  }

  &::-webkit-scrollbar-track {
    background: transparent; 
  }
  }

    @media (max-width: 756px) {
     max-width: 100%;
     width: 100%;
   }
`;

export const CustomSelect = styled.div`
  width: 200px;
  position: relative;
`;

export const SelectButton = styled.div`
  padding: 0.625rem;
  
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  color: white;
  cursor: pointer;
  user-select: none;
  border-radius: 01.25rem;
  background: ${theme.colors.gray.Cinza_2};
`;

export const Arrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;

  &.open {
    transform: rotate(180deg);
  }
`;

export const SelectOptions = styled.div`
  top: ${props => (props.openUp ? "auto" : "110%")};
  bottom: ${props => (props.openUp ? "110%" : "auto")};
  z-index: 3;
  width: 100%;
  position: absolute;
  
  display: flex;
  flex-direction: column;
  
  overflow: hidden;
  background: white;
  border-radius: 0.625rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
`;

export const Option = styled.div`
  padding: 0.625rem;
  text-align: start;
  
  cursor: pointer;
  transition: 0.3s;
  
  &:hover {
    background: #eee;
  }

  input {
    margin: 0px 8px 0px 0px;
    cursor: pointer;
    background-color: red;
  }
`;

export const SelectButtonOthersFilters = styled.div`
  padding: 0.625rem;
  
  display: flex;
  align-items: center;
  
  cursor: pointer;
  user-select: none;
  border-radius: 1.25rem;
  background: ${props => (props.selected ? "#21262F" : "#FFF")};
  border: 1px solid ${theme.colors.gray.Cinza_2};

  >p {
    margin-right: .5rem;
  }
`;

export const ArrowOthersFilters = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  
  transition: transform 0.3s;

  &.open {
    transform: rotate(180deg);
  }

  img {
    filter: ${props => (props.selected ? "invert(0)" : "invert(1)")};
  }
`;

// export const CustomSelectOtherFiltes = styled.div`
//   max-height: 2rem;
//   position: relative;
//   width: fit-content;
//   max-width: 12.25rem;

//   @media (max-width: 756px) {
//     max-width: 100%;
//   }
// `;

export const BiologicoSwitch = styled.div`
  gap: 0.5rem;
  display: flex;
  cursor: pointer;
  align-items: center;

  span {
      font-size: 0.6875rem;
      font-weight: 600;
      letter-spacing: 0.1rem;
      line-height: 1.0313rem;
      font-family: 'Lato', sans-serif;
  }
`;

export const SwitchContainer = styled.div`
  width: 2.5rem;
  height: 1.25rem;
  padding: 0.125rem;
  
  display: flex;
  align-items: center;
  
  position: relative;
  border-radius: 0.625rem;
  transition: background 0.3s ease;
  background: ${({ isActive }) => (isActive ? `${theme.colors.green.Verde_AgroReceita}` : "#D3D3D3")};
`;

export const SwitchCircle = styled.div`
  width: 1rem;
  height: 1rem;
  left: ${({ isActive }) => (isActive ? "1.25rem" : ".125rem")};
  
  background: white;
  border-radius: 50%;
  position: absolute;
  transition: left 0.3s ease;
`;

export const ModalBody = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  text-align: ${props => props.textAlign ? props.textAlign : 'center'};
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : '32px'} ;
`;

export const ButtonPlans = styled.div`
     width: 100%;
     display: flex;
     margin-top: 1.25rem;
     margin-bottom: 0.938rem;
     flex-direction: row;
     justify-content: center; 
`;

export const ContainerContent = styled.div`
  width: 100%;
  height: auto;
  max-width: 28.75rem;

  >img{
      @media (max-width: 480px) {
            width: 8rem;
      }
    }

  >h5{
      margin-top: 1rem;

      @media (max-width: 480px) {
          font-size: 1.4rem;
      }
  }

  >p{
     margin-top: 1rem;

      >span{
        @media (max-width: 480px) {
          font-size: 1rem;
        }
      }

     @media (max-width: 480px) {
          font-size: 1rem;
      }
  }

  >p:nth-of-type(2){
      margin-top: 0.5rem;

      @media (max-width: 480px) {
            font-size: 0.9rem;
            line-height: 1rem;
      }
  }

    >div >div {
        >div:nth-of-type(1) {}

        >div:nth-of-type(2) {
          margin-bottom: 0;      
        }
    }
`;

export const ContainerModal = styled.div`
  width: 100%;
  height: auto;
  max-width: 28.75rem;

  >img{
      @media (max-width: 480px) {
            width: 8rem;
      }
    }

  >h5{
      margin-top: 1rem;

      @media (max-width: 480px) {
          font-size: 1.4rem;
      }
  }

  >p{
     margin-top: 1rem;

      >span{
        @media (max-width: 480px) {
          font-size: 1rem;
        }
      }

     @media (max-width: 480px) {
          font-size: 1rem;
      }
  }

  >p:nth-of-type(2){
      margin-top: 0.5rem;

      @media (max-width: 480px) {
            font-size: 0.9rem;
            line-height: 1rem;
      }
  }

    >div >div {
        >div:nth-of-type(1) {}

        >div:nth-of-type(2) {
          margin-bottom: 0;      
        }
    }
`;